import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useQueryState } from 'nuqs';
import { resolvePortfolioUrlToPersist, resolveReferrerToPersist, resolveUtmReferrerValues } from './resolve-utm-referrer-values';
import { useSafeLocalStorage } from './use-safe-local-storage';
const REFERRER_STORAGE_KEYS = {
  referrer: '__utm_referrer',
  portfolioUrl: '__portfolio_url'
} as const;
export interface PersistedReferrerParams {
  portfolioUrl: string | null;
  referrer: string;
  setPortfolioUrl: (value: string) => void;
  setReferrer: (value: string) => void;
}

/**
 * Referrer + portfolio URL need custom merge rules: a public portfolio URL in
 * `referrer` is attribution, not a referral code.
 */
export function usePersistedReferrerParams() {
  const $ = _c(26);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      defaultValue: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [urlReferrer] = useQueryState("referrer", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValue: ""
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [urlUtmReferrer] = useQueryState("utm_referrer", t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      defaultValue: ""
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [urlPortfolioUrl] = useQueryState("portfolio_url", t2);
  const [storedReferrer, setStoredReferrer] = useSafeLocalStorage(REFERRER_STORAGE_KEYS.referrer, "");
  const [storedPortfolioUrl, setStoredPortfolioUrl] = useSafeLocalStorage(REFERRER_STORAGE_KEYS.portfolioUrl, "");
  let t3;
  if ($[3] !== storedPortfolioUrl || $[4] !== storedReferrer || $[5] !== urlPortfolioUrl || $[6] !== urlReferrer || $[7] !== urlUtmReferrer) {
    t3 = resolveUtmReferrerValues({
      urlReferrer,
      urlUtmReferrer,
      urlPortfolioUrl,
      storedReferrer,
      storedPortfolioUrl
    });
    $[3] = storedPortfolioUrl;
    $[4] = storedReferrer;
    $[5] = urlPortfolioUrl;
    $[6] = urlReferrer;
    $[7] = urlUtmReferrer;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    referrer,
    portfolioUrl
  } = t3;
  let t4;
  let t5;
  if ($[9] !== setStoredPortfolioUrl || $[10] !== storedPortfolioUrl || $[11] !== urlPortfolioUrl || $[12] !== urlReferrer) {
    t4 = () => {
      const portfolioUrlValue = resolvePortfolioUrlToPersist({
        urlPortfolioUrl,
        urlReferrer
      });
      if (portfolioUrlValue && portfolioUrlValue !== storedPortfolioUrl) {
        setStoredPortfolioUrl(portfolioUrlValue);
      }
    };
    t5 = [urlPortfolioUrl, urlReferrer, storedPortfolioUrl, setStoredPortfolioUrl];
    $[9] = setStoredPortfolioUrl;
    $[10] = storedPortfolioUrl;
    $[11] = urlPortfolioUrl;
    $[12] = urlReferrer;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[15] !== setStoredReferrer || $[16] !== storedReferrer || $[17] !== urlReferrer || $[18] !== urlUtmReferrer) {
    t6 = () => {
      const referrerValue = resolveReferrerToPersist({
        urlReferrer,
        urlUtmReferrer
      });
      if (referrerValue && referrerValue !== storedReferrer) {
        setStoredReferrer(referrerValue);
      }
    };
    t7 = [urlReferrer, urlUtmReferrer, storedReferrer, setStoredReferrer];
    $[15] = setStoredReferrer;
    $[16] = storedReferrer;
    $[17] = urlReferrer;
    $[18] = urlUtmReferrer;
    $[19] = t6;
    $[20] = t7;
  } else {
    t6 = $[19];
    t7 = $[20];
  }
  useEffect(t6, t7);
  let t8;
  if ($[21] !== portfolioUrl || $[22] !== referrer || $[23] !== setStoredPortfolioUrl || $[24] !== setStoredReferrer) {
    t8 = {
      referrer,
      portfolioUrl,
      setReferrer: setStoredReferrer,
      setPortfolioUrl: setStoredPortfolioUrl
    };
    $[21] = portfolioUrl;
    $[22] = referrer;
    $[23] = setStoredPortfolioUrl;
    $[24] = setStoredReferrer;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}